import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/courses/Main.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layout/MemoAuthWrapper.tsx");
